/*
 * The forms of the e-mail addresses of the persons of a company (backend EmailFormats). The
 * e-mail of a new contact person is made of the form, the names of the person and the
 * e-mail ending of the company; the user can still type another one.
 */
export const EMAIL_FORMATS = [
  'firstname.lastname',
  'f.lastname',
  'flastname',
  'firstnamelastname',
  'firstname_lastname',
  'firstname-lastname',
  'lastname.firstname',
  'firstname.l',
  'firstname',
];

// E.g. "Äijälä-Öhman" -> "aijala-ohman": no accents, spaces or other characters
const toAddressPart = (name: string): string =>
  name
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

const parts: Record<string, (first: string, last: string) => string | null> = {
  'firstname.lastname': (first, last) => `${first}.${last}`,
  'f.lastname': (first, last) => `${first.charAt(0)}.${last}`,
  flastname: (first, last) => `${first.charAt(0)}${last}`,
  firstnamelastname: (first, last) => `${first}${last}`,
  firstname_lastname: (first, last) => `${first}_${last}`,
  'firstname-lastname': (first, last) => `${first}-${last}`,
  'lastname.firstname': (first, last) => `${last}.${first}`,
  'firstname.l': (first, last) => `${first}.${last.charAt(0)}`,
  firstname: (first) => first,
};

/**
 * The e-mail of a person made of the form of the company, e.g. matti.meikalainen@inlook.fi;
 * empty when the form, the ending or a name the form needs is missing.
 */
export const makeEmail = (
  format: null | string | undefined,
  firstName: string,
  lastName: string,
  emailEnding: null | string | undefined
): string => {
  const ending = (emailEnding ?? '').trim().replace(/^@/, '');
  const make = format ? parts[format] : undefined;
  const first = toAddressPart(firstName);
  const last = toAddressPart(lastName);
  const needsLast = format !== 'firstname';
  if (!make || ending === '' || first === '' || (needsLast && last === '')) {
    return '';
  }

  return `${make(first, last)}@${ending}`;
};
